<body>
  <section class="background">
    <div class="container-fluid">
      <div class="row jutify-content-center">
        <div class="col-lg-3 text-center mt-3">
          <div class="social-image mt-3">
            <a href="http://onpassive.com/blog" target="_blank" rel="noopener">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-2)/assets/image/icon/blog1.png"
                title="ONPASSIVE Blog"
                class="icon1"
                alt="blog1"
              />
            </a>
            <a
              href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
              target="_blank"
              rel="noopener"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-2)/assets/image/icon/fb.png"
                title="Facebook"
                class="icon"
                alt="facebook"
              />
            </a>
            <a
              href="https://twitter.com/ONPASSIVE"
              target="_blank"
              rel="noopener"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-2)/assets/image/icon/twitter.png"
                title="Twitter"
                class="icon"
                alt="Twitter"
              />
            </a>
            <a
              href="https://www.instagram.com/ONPASSIVE/"
              target="_blank"
              rel="noopener"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-2)/assets/image/icon/insta.png"
                title="Instagram"
                class="icon"
                alt="Instagram"
              />
            </a>
            <a
              href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
              target="_blank"
              rel="noopener"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-2)/assets/image/icon/youtube.png"
                title="Youtube"
                class="icon"
                alt="YouTube"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
              target="_blank"
              rel="noopener"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-2)/assets/image/icon/in.png"
                title="LinkedIn"
                class="icon"
                alt="LinkedIn"
              />
            </a>
          </div>
        </div>
        <div class="col-lg-6 text-right">
          <div class="middle">
            <img
              src="{{
                onPassiveBaseUrl
              }}onpassive(jan-2)/assets/image/newyear.png"
              class="newyear" alt="NewYear"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-2)/assets/image/no1.png"
              class="no1" alt="No1"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-2)/assets/image/no2.png"
              class="no2" alt="No2"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-2)/assets/image/no3.png"
              class="no3" alt="No3"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-2)/assets/image/no5.png"
              class="swingimage no5" alt="No5"
            />
          </div>
        </div>
        <div class="col-lg-3 mt-3 text-right">
          <div class="logo">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(jan-2)/assets/image/logo.png" alt="logo"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center mt-5">
        <div class="col-lg-10 text-right mt-5">
          <h1 class="font2 ml10">
            <span class="text-wrapper">
              <span class="letters">LAUNCHING SOON</span>
            </span>
          </h1>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center mac">
        <div class="col-lg-3"></div>
        <div class="col-lg-6">
          <div class="video-box">
            <video
              id="my-video"
              class="
                video-js video-size
                w-100
                h-auto
                my-video-dimensions
                shadow
              "
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video2.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
        <div class="col-lg-3">
          <p class="font1">
            Kick-start the year 2020 with a brilliant business opportunity. This
            year we bring you an opportunity to rebuild your life. ONPASSIVE
            with its roots deep in Digital Marketing and Artificial Intelligence
            is standing strong in the world of marketing. We are a disruptive
            business platform for people who are hungry for a change in their
            life.
          </p>
          <a
            href="/registration/user?reg={{ userId }}"
            class="btn btn-3 mac1"
            id="regform1111"
            name="regform"
            target="_blank"
            rel="noopener"
            >BECOME A FOUNDER NOW</a
          >
        </div>
      </div>
    
    </div>
  </section>
</body>
